// extracted by css-extract-rspack-plugin
export default {"root":"root-ugr4OV","filter":"filter-viMvGL","filters":"filters-fg9OU2"};